import styled from 'styled-components'

export const LoadingContainer = styled.div`
  height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
`
